import { render } from "./burger_menu.vue?vue&type=template&id=36d462e4&scoped=true"
import script from "./burger_menu.vue?vue&type=script&lang=js"
export * from "./burger_menu.vue?vue&type=script&lang=js"

import "./burger_menu.vue?vue&type=style&index=0&id=36d462e4&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d462e4"]])

export default __exports__